import { CheckboxOption, RadioGroupProps } from "@/components/RadioGroup/RadioGroupProps.ts";
import { useState } from "react";

const RadioGroup = (props: RadioGroupProps) => {
  const options: CheckboxOption[] = props.options;
  const [selectedOption, setSelectedOption] = useState(props.value || options[0].value);

  const handleRadioChange = (value: string) => {
    setSelectedOption(value);
    props.onChange(value);
  };

  return (
    <div className="radioGrpWrap">
      {options?.map((option) => (
        <label className="radioGrpItemlabel" key={option.value}>
          <input
            type="radio"
            checked={selectedOption === option.value}
            onChange={() => handleRadioChange(option.value)}
            className="radioGroup"
          />
          <span className="radioLabel">{option.label}</span>
        </label>
      ))}
    </div>
  );
};

export default RadioGroup;
